import React, { useEffect, useState } from "react";
import "./frieghtcalculator.scss";
import { Checkbox, TreeviewDropdown } from "../../../CommonComponent";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../../const/resource";
import { IProps } from "./frieghtcalculatorinterface";
import { useSelector } from "react-redux";
import { selectors as globalDataSelector } from "../../../../state/features/common/globaldata";
import { selectors as headerSelector } from "../../../../state/features/header";
import partsService from "../../../../services/partsservice";
import Alerts from "../../../Alerts";
import helperfunctions from "../../../../utils/helperfunctions";
import Loader from "../../../Loader";
import { ICartContextType } from "../shoppingcartpromointerface";
import { useCartContext } from "../../shoppingcart";
import { Tooltip } from "@progress/kendo-react-tooltip";

const FreightCalculator = (props: IProps) => {
    const { t } = useTranslation();
    const { globalData, headercurrentuser }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
        headercurrentuser: headerSelector.currentuser(state),
    }));

    const [deliveryToOption, setDeliveryToOption] = useState<any>({loading: false, data: []});
    const [shippingMethodOption, setShippingMethodOption] = useState<any>({loading: false, data: []});
    const [shippingCarrierOption, setShippingCarrierOption] = useState<any>({loading: false, data: {}});
    const [deliveryTo, setDeliveryTo] = useState<any>("");
    const [shippingMethodId, setShippingMethodId] = useState<any>("");
    const [serviceTypeId, setServiceTypeId] = useState<any>("");
    const [excludeItem, setExcludeItem] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<any>("");
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [isCalculated, setIsCalculated] = useState<boolean>(false);
    const [selectedDeliveryToOption, setSelectedDeliveryToOption] = useState<any>(null);
    const [selectedCarrier, setSelectedCarrier] = useState<any>(null);
    const [isDropboxOrDelivery, setIsDropboxOrDelivery] = useState<boolean>(false);
    const [shippingCostResponse, setShippingCostResponse] = useState<any>({loading: false, data: false});
    const { isGuestUser }: ICartContextType = useCartContext();
    const [isExcludeItemCarriesLoading, setIsExcludeItemCarriesLoading] = useState<boolean>(false);

    useEffect(() => {
        getDelivertToOption();
        getShippingMethods();
    }, []);

    useEffect(() => {
        if (shippingMethodId && shippingMethodId > 0 && selectedDeliveryToOption?.value) {
            getShippingCarriers(shippingMethodId, selectedDeliveryToOption, false);
        }

    }, [shippingMethodId, selectedDeliveryToOption])

    useEffect(() => {
        if (shippingMethodId && shippingMethodId > 0 && selectedDeliveryToOption?.value) {
            getShippingCarriers(shippingMethodId, selectedDeliveryToOption, true);
        }

    }, [excludeItem])


    const getFullAddressForDeliveryTo = (address : any) => {
        let fullAddress = '';
        const address1 = address?.address1?.trim();
        const address2 = address?.address2?.trim();
        const address3 = address?.address3?.trim();
        const city = address?.city?.trim();
        const stateName = address?.stateName?.trim();
        const countryName = address?.countryName?.trim();
        const displayName = address?.displayName?.trim();
        if (address1) {
            fullAddress += `${address1}, `;
        }
        if (address2) {
            fullAddress += `${address2}, `;
        }
        if (address3) {
            fullAddress += `${address3}, `;
        }
        if (city) {
            fullAddress += `${city}, `;
        }
        if (stateName) {
            fullAddress += `${stateName}, `;
        }
        if (countryName) {
            fullAddress += `${countryName}, `;
        }
        if (displayName) {
            fullAddress += `${displayName}`;
        }

        return fullAddress;
    }

    const getDelivertToOption = async () => {
        try {
            setDeliveryToOption({loading: true, data: []})
            const reqBody = {
                orderId: 0,
                userAadId: headercurrentuser?.azureADId,
                customerId: globalData?.CustomerId ?? "",
                addressType: 0,
                isGuest: headercurrentuser?.isGuestUser
            };
            const response = await partsService.getSavedAddressList(reqBody);
            if (response?.isSuccess) {
                const selectedAddress = response?.data?.addresses?.find((t: any) => t.isSelected);
                setSelectedDeliveryToOption(selectedAddress);
                setDeliveryTo(selectedAddress?.addressId ?? "");
                setDeliveryToOption({loading: false, data:
                    response?.data?.addresses?.filter((t: any) => t.addressId > 0)?.map((item: any) => {
                        return {
                            value: item?.addressId,
                            title: getFullAddressForDeliveryTo(item),
                            ...item
                        };
                    }) ?? []
                });
            } else {
                setDeliveryToOption({loading: false, data: []});
            }
        } catch (error) {
            setDeliveryToOption({loading: false, data: []});
        }
    };

    const getShippingMethods = async () => {
        try {
            const reqBody = {
                cartId: props?.cartsDetails?.cart?.cartId ?? 0,
                userAadId: headercurrentuser?.azureADId ?? "",
            };
            setShippingMethodOption({loading: true, data: []})
            const response = await partsService.getShippingMethods(reqBody);
            if (response?.isSuccess) {
                const defaultShippingMethodId = response?.data?.shippingMethodDetail?.find((t: any) => t.isSelected)?.shippingMethodId ?? "";
                setShippingMethodId(defaultShippingMethodId);
                const data = response?.data?.shippingMethodDetail?.map((t: any) => ({ title: t.shippingMethod, value: t.shippingMethodId }))  ?? [];
                const defaultOption = { value: '', title: t(RESOURCE.MyK_Please_Select) };
                setShippingMethodOption({loading: false, data: [defaultOption, ...data] });
            } else {
                setShippingMethodOption({loading: false, data: []});
            }
        } catch (error) {
            setShippingMethodOption({loading: false, data: []});
        }
    };

    const getValueOrDefaultEmpty = (value :any) => {
        return value ?? "";
    }

    const getCarries = (response: any) => {
        const defaultOption = { value: '', title: t(RESOURCE.MyK_Please_Select) };
        return (Array.isArray(response?.data?.carriers) && response?.data?.carriers.length > 0 ? [defaultOption, ...response.data.carriers ?? []] : [])
    }

    const getShippingCarriers = async (shippingMethodId: any, selectedDeliveryToOption: any, isFromExcludeItems: any) => {
        try {
            setIsCalculated(false);
            setShippingCostResponse({ loading: false, data: false });
            setIsExcludeItemCarriesLoading(true);
            if (!isFromExcludeItems) {
                setServiceTypeId("");
                setShippingCarrierOption({ loading: true, data: {} });
            }
            const reqBody = {
                cartId: props?.cartsDetails?.cart?.cartId,
                customerId: getValueOrDefaultEmpty(globalData?.CustomerId),
                shippingMethodCode: shippingMethodId,
                userAadId: getValueOrDefaultEmpty(headercurrentuser?.azureADId),
                shipToAddressId: deliveryTo,
                excludePickupItems: excludeItem,
                partNumbers: getValueOrDefaultEmpty(props?.partNumber),
                shipToAddress: {
                    "addressType": selectedDeliveryToOption?.addressType,
                    "firstName": selectedDeliveryToOption?.firstName,
                    "lastName": selectedDeliveryToOption?.lastName,
                    "companyName": selectedDeliveryToOption?.companyName || (isGuestUser ? selectedDeliveryToOption?.firstName : globalData?.CustomerName),
                    "companyId": selectedDeliveryToOption?.customerId,
                    "address1": selectedDeliveryToOption?.address1,
                    "address2": selectedDeliveryToOption?.address2,
                    "countryCode": selectedDeliveryToOption?.countryCode,
                    "stateCode": selectedDeliveryToOption?.stateCode,
                    "city": selectedDeliveryToOption?.city,
                    "postalCode": selectedDeliveryToOption?.postalCode,
                    "addressId": selectedDeliveryToOption?.addressId,
                    "phone": selectedDeliveryToOption?.phone,
                    "phoneCountryCode": selectedDeliveryToOption?.phoneCountryCode,
                    "attention": selectedDeliveryToOption?.attention
                }
            }
            const response = await partsService.getShippingCarriers(reqBody);
            const carriers = getCarries(response);
            if (response?.isSuccess) {
                const defaultCarrieId = getValueOrDefaultEmpty(carriers?.find((t: any) => t.isSelected)?.id);
                if (!isFromExcludeItems) {
                    setServiceTypeId(defaultCarrieId);
                    setSelectedCarrier(carriers?.find((t: any) => t.isSelected));
                }
                else {
                    let serviceTypeIdSelected = serviceTypeId;
                    if (serviceTypeIdSelected == "") {
                        setServiceTypeId(defaultCarrieId);
                        serviceTypeIdSelected = defaultCarrieId;
                    }
                    setSelectedCarrier(carriers?.find((t: any) => t.id == serviceTypeIdSelected));
                }
                setIsExcludeItemCarriesLoading(false);
                setShippingCarrierOption({ loading: false, data: { ...response?.data, carriers: carriers?.map((t: any) => ({ title: t.carrierName, value: t.id, ...t })) ?? [] } });
            } else {
                setIsExcludeItemCarriesLoading(false);
                setShippingCarrierOption({loading: false, data: {}});
            }
        } catch (error) {
            setIsExcludeItemCarriesLoading(false);
            setShippingCarrierOption({loading: false, data: {}});
        }
    };

    const calculateShippingCost = async () => {
        if (!deliveryTo) {
            showAlertErrorMessage(t(RESOURCE.MyK_Label_SC_FC_DeliveryToRequired));
            return;
        }
        if (!shippingMethodId) {
            showAlertErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Shipping_Method_Req));
            return;
        }
        if (!serviceTypeId) {
            showAlertErrorMessage(t(RESOURCE.MyK_Label_SC_Carrier_Selection_Warning));
            return;
        }

        setShippingCostResponse({ loading: true, data: false });

        const timer = setTimeout(() => {
            setShippingCostResponse({ loading: false, data: false });
            setIsCalculated(true)
        }, 2000);

        return () => clearTimeout(timer);
    };

    const showAlertErrorMessage = (message: any) => {
        setErrorMessage(message);
        setShowAlert(true);
    };

    const handleErrorClose = () => {
        setErrorMessage("");
        setShowAlert(false);
    };

    const onDeliveryToChange = (value: any, extra: any) => {
        setDeliveryTo(value);
        setServiceTypeId("");
        setIsCalculated(false);
        setSelectedDeliveryToOption(extra);
        setShippingCostResponse({loading: false, data: false});
    }

    const onChangeCarrier = (value: any, extra: any) => {
        if (value != serviceTypeId) {
            setServiceTypeId(value);
            setSelectedCarrier(extra);
            setIsCalculated(false);
            setShippingCostResponse({ loading: false, data: false });
        }
    }

    return (
        <div className="row">
            {(shippingCostResponse?.loading || shippingCarrierOption?.loading || shippingMethodOption?.loading || deliveryToOption?.loading || isExcludeItemCarriesLoading) && <Loader />}
            <div className="col-12">
                <div className="freight-wrapper">
                    {showAlert && (
                        <Alerts
                            messageAlert={errorMessage}
                            alertType={"error"}
                            time={3000}
                            onClose={() => handleErrorClose()}
                        />
                    )}
                    <div className="frieghtlabel">
                        {t(RESOURCE.MyK_Label_SC_DeliverTo)}:
                        <span className="mandatory">*</span>
                    </div>
                    <div className="deliverDropdown mt-3">
                        <TreeviewDropdown
                            treeData={deliveryToOption?.data}
                            showSearch={true}
                            dropdownClassName={"dropdownListContainer noNested"}
                            placeholder={""}
                            treeNodeFilterProp={"title"}
                            value={deliveryTo}
                            onChange={(value: any, _: any, extra: any) => {
                                onDeliveryToChange(value, extra?.triggerNode?.props);
                            }}
                        />

                    </div>
                    <div className="frieghtlabel mt-3">
                        {t(RESOURCE.MyK_Label_SC_Shipping_Method)}
                        <span className="mandatory">*</span>
                    </div>
                    <div className="frieghtDescription mt-3">
                        {t(RESOURCE.MyK_Label_SC_FC_OrderEstimation)}
                    </div>
                    <div className="shippingMethodDropdown mt-3">
                        <TreeviewDropdown
                            treeData={shippingMethodOption?.data}
                            showSearch={true}
                            dropdownClassName={"dropdownListContainer noNested"}
                            placeholder={""}
                            treeNodeFilterProp={"title"}
                            value={shippingMethodId}
                            onChange={(value: any, title :any) => {
                                const selectedTitle = title?.length > 0 ? title[0]?.toLowerCase() : "";
                                setIsDropboxOrDelivery(selectedTitle == "delivery" || selectedTitle == "dropbox" || selectedTitle == "freight truck");
                                setShippingMethodId(value);
                                if (!value || value == "") {
                                    setSelectedCarrier(null);
                                    setShippingCarrierOption({ loading: false, data: {} });
                                }
                            }}
                        />

                    </div>
                    {shippingCarrierOption?.data?.carriers?.length > 0 &&
                        <><div className="frieghtlabel mt-3">
                            {t(RESOURCE.MyK_Label_SC_Select_Carrier)}
                            <span className="mandatory">*</span>
                        </div>
                            <div className="deliverDropdown mt-3">
                                <TreeviewDropdown
                                    treeData={shippingCarrierOption?.data?.carriers ?? []}
                                    showSearch={true}
                                    dropdownClassName={"dropdownListContainer noNested"}
                                    placeholder={""}
                                    treeNodeFilterProp={"title"}
                                    value={serviceTypeId}
                                    onChange={(value: any, _: any, extra: any) => {
                                        onChangeCarrier(value, extra?.triggerNode?.props)
                                    }}
                                />
                            </div></>}
                    {isDropboxOrDelivery ?
                        <div className="freightError mt-3">{t(RESOURCE.Myk_Label_SC_Shipping_Option_Warning)}</div>
                        : <>
                            <div className="mt-3 Fright_Checkbox">
                                <Checkbox
                                    label={t(RESOURCE.MyK_Label_SC_FC_ExcludeItem)}
                                    checked={excludeItem}
                                    onChange={(e: any) => setExcludeItem(e.target.checked)}
                                />
                            </div>
                            {((!shippingCarrierOption?.data?.errors?.length && !shippingCarrierOption?.data?.warnings?.length && !shippingCarrierOption?.data?.carriers?.length) || ((!shippingCarrierOption?.data?.errors?.length || !shippingCarrierOption?.data?.warnings?.length) && shippingCarrierOption?.data?.carriers?.length > 0)) && <div className="mt-3">
                                <button
                                    className="calculateBtn"
                                    title={t(RESOURCE.MyK_Label_SC_FC_Calculate)}
                                    onKeyDown={() => { }}
                                    onClick={calculateShippingCost}
                                >
                                    {t(RESOURCE.MyK_Label_SC_FC_Calculate)}
                                </button>
                            </div>}
                            {isCalculated && <>
                                <div className="mt-3 freightHeadingview clearfix">
                                    <div className="freightHeading">
                                        {t(RESOURCE.MyK_Label_SC_FC_EstimatedFreight)}
                                    </div>
                                    <div className="infoview">
                                        <Tooltip openDelay={100} position="right" className="freighttooltip" anchorElement="target">
                                            <span
                                                title={t(RESOURCE.MyK_Label_SC_FC_InfoMessage)}
                                                className="fa fa-info-circle circleinfo"
                                            >
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className="frieghtRate mt-3">${helperfunctions.formatAmount(selectedCarrier?.shippingcharges?.amount ?? 0)}</div>

                            </>}
                        </>
                    }

                    {shippingCarrierOption?.data?.warnings?.map((t: any) =>
                        <div key={t['message']} className="freightError mt-3"> <span className="shipping-err-category">{t['category']}: </span>{t['message']}</div>
                    )}

                    {shippingCarrierOption?.data?.errors?.map((t: any) =>
                        <div key={t['message']} className="freightError mt-3"><span className="shipping-err-category">{t['category']}: </span>{t['message']}</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FreightCalculator;
